import React from 'react';
import cx from 'classnames';
import { BACK } from '../../../../constants/Copy';

import './BackButton.scss';
import { getImageUrl } from '../../../../config';

const icon = getImageUrl('/images/onboarding/button-back.svg');

export default ({ className, onClick }) => (
	<button className={cx('back-button', { [className]: !!className })} onClick={onClick}>
		<img src={icon} className="back-button__icon" />
		<span className="back-button__label">{BACK}</span>
	</button>
);
